import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-nav"
export default class extends Controller {
  static targets = ["menu", "overlay", "hamburger", "close", "toggleButton"]

  connect() {
    // Ensure menu starts in closed state
    this.menuTarget.classList.add("hidden")
    this.overlayTarget.classList.add("hidden")
    this.hamburgerTarget.classList.remove("hidden")
    this.closeTarget.classList.add("hidden")
    this.toggleButtonTarget.setAttribute("aria-expanded", "false")

    // Store bound references for proper cleanup
    this.boundHandleEscapeKey = this.handleEscapeKey.bind(this)
    this.boundHandleResize = this.handleResize.bind(this)

    document.addEventListener("keydown", this.boundHandleEscapeKey)
    window.addEventListener("resize", this.boundHandleResize)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscapeKey)
    window.removeEventListener("resize", this.boundHandleResize)
  }

  toggle() {
    if (this.isMenuOpen()) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  openMenu() {
    // Prevent body scrolling when menu is open
    document.body.classList.add('mobile-nav-open')
    document.body.style.overflow = 'hidden'
    
    // Show elements (they start with transform: translateX(100%))
    this.menuTarget.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")
    
    // Switch hamburger to close icon
    this.hamburgerTarget.classList.add("hidden")
    this.closeTarget.classList.remove("hidden")
    
    // Force a reflow to ensure elements are rendered before animation
    this.menuTarget.offsetHeight
    
    // Start slide-in animation
    requestAnimationFrame(() => {
      this.menuTarget.classList.add("menu-open")
      this.overlayTarget.classList.add("overlay-open")
    })

    // Set aria-expanded for accessibility
    this.toggleButtonTarget.setAttribute("aria-expanded", "true")
  }

  closeMenu() {
    // Start slide-out animation by removing the open class
    this.menuTarget.classList.remove("menu-open")
    this.overlayTarget.classList.remove("overlay-open")
    
    // Switch close icon back to hamburger
    this.hamburgerTarget.classList.remove("hidden")
    this.closeTarget.classList.add("hidden")
    
    // Hide elements after animation completes
    setTimeout(() => {
      this.menuTarget.classList.add("hidden")
      this.overlayTarget.classList.add("hidden")
      
      // Restore body scrolling
      document.body.classList.remove('mobile-nav-open')
      document.body.style.overflow = ''
    }, 300) // Match CSS transition duration

    // Set aria-expanded for accessibility
    this.toggleButtonTarget.setAttribute("aria-expanded", "false")
  }

  isMenuOpen() {
    return !this.menuTarget.classList.contains("hidden")
  }

  handleEscapeKey(event) {
    if (event.key === "Escape" && this.isMenuOpen()) {
      this.closeMenu()
    }
  }

  handleResize(event) {
    // Close mobile menu when window becomes desktop sized
    if (window.innerWidth >= 768 && this.isMenuOpen()) {
      this.closeMenu()
    }
  }
}